import React, { useEffect, useContext, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { MyCollaborationsContainer, ProfileImage } from "./MyCollaborationsStyled";
import { FormattedMessage } from 'react-intl';

import { UserContext } from "../../context/userContext";
import { CollaborationsContext } from "../../context/collaborationsContext";

import back from './../../utils/images/arrow_back.svg';
import avatar from './../../utils/images/avatar_fluincr.png';

import { getActiveCollaborationByInfluencer, getNotActiveCollaborationByInfluencer, getActiveCollaborationByCompany, getNotActiveCollaborationByCompany, patchCollaboration } from "../../api/collaborationApi";

import CollaborationItem from "./CollaborationItem";


export default function MyCollaborations() {

    const navigate = useNavigate();

    const { id, userType } = useContext(UserContext);
    const isAdmin = sessionStorage.getItem('isAdmin');

    const [showActiveCollaborations, setShowActiveCollaborations] = useState(false);
    const [showNotActiveCollaborations, setShowNotActiveCollaborations] = useState(false);

    const { activeCollaborations, setActiveCollaborations, notActiveCollaborations, setNotActiveCollaborations, collaborationNotificationCount, setCollaborationNotificationCount } = useContext(CollaborationsContext);

    useEffect(() => {

        if (id !== null) {
            if (userType === 'influencer') {
                getActiveCollaborationByInfluencer({ influencerId: id }).then((response) => {
                    setActiveCollaborations(response)
                    let suma = 0
                    for (let i = 0; i < response.length; i++) {
                        if (response[i].readinfluencer === false) {
                            suma += 1;
                        }
                    }
                    setCollaborationNotificationCount(suma);
                    setShowActiveCollaborations(true);
                })
                getNotActiveCollaborationByInfluencer({ influencerId: id }).then((response) => {
                    setNotActiveCollaborations(response);
                    setShowNotActiveCollaborations(true);
                })

            } else {
                getActiveCollaborationByCompany({ companyId: id }).then((response) => {
                    setActiveCollaborations(response)
                    let suma = 0

                    for (let i = 0; i < response.length; i++) {
                        if (response[i].readcompany === false) {
                            suma += 1;
                        }
                    }

                    setCollaborationNotificationCount(suma);
                    setShowActiveCollaborations(true);
                })
                getNotActiveCollaborationByCompany({ companyId: id }).then((response) => {
                    setNotActiveCollaborations(response)
                    setShowNotActiveCollaborations(true);
                })
            }

        }
    }, [id])

    const handlerSeeCollaboration = (collaborationId) => {
        const body = {}

        if (userType === 'influencer' && isAdmin !== true) {
            body.readinfluencer = true
        } else if ((userType === 'company' && isAdmin !== true)) {
            body.readcompany = true
        }

        if (isAdmin !== true) {
            patchCollaboration({ collaborationId: collaborationId, collaborationBody: body }).then((response) => {
                setCollaborationNotificationCount(collaborationNotificationCount - 1)
                navigate(`${collaborationId}`)
            })
        } else {
            navigate(`${collaborationId}`)
        }

    }


    return (
        <MyCollaborationsContainer>
            <hr />
            <div className="goBack" onClick={() => navigate(-1)}>
                <img src={back} alt="back" className="backIcon" />
                <p className="backText" ><FormattedMessage id="go_back" defaultMessage="ir atrás" /></p>
            </div>
            {
                (userType === 'influencer') ? (
                    <>
                        <section>
                            <h3><FormattedMessage id="my_collaborations_title_1" defaultMessage="Colaboraciones actuales" /></h3>

                            <table>
                                {(showActiveCollaborations === true) && (activeCollaborations?.map((collaboration) => {
                                    return (
                                        <CollaborationItem collaboration={collaboration} handlerSeeCollaboration={handlerSeeCollaboration} key={collaboration.id} />
                                    )
                                }))}

                            </table>

                            {(activeCollaborations.length < 1) && (<div className="notCollaborations">
                                <p><FormattedMessage id="my_collaborations_text_1" defaultMessage="No tienes colaboraciones activas" /></p>
                            </div>)}

                        </section>
                        <section >
                            <h3><FormattedMessage id="my_collaborations_title_2" defaultMessage="Colaboraciones pasadas" /></h3>
                            <table className="pastCollaborations">
                                {(showNotActiveCollaborations === true) && (notActiveCollaborations?.map((collaboration) => {
                                    return (
                                        <CollaborationItem collaboration={collaboration} handlerSeeCollaboration={handlerSeeCollaboration} />)
                                }))}

                            </table>
                            {(notActiveCollaborations.length < 1) && (<div className="notCollaborations">
                                <p><FormattedMessage id="my_collaborations_text_2" defaultMessage="No tienes colaboraciones pasadas" /></p>
                            </div>)}

                        </section>
                    </>
                ) : (
                    <>
                        <section>
                            <h3><FormattedMessage id="my_collaborations_title_1" defaultMessage="Colaboraciones actuales" /></h3>

                            <table>
                                {(showActiveCollaborations === true) && (activeCollaborations?.map((collaboration) => {
                                    return (
                                        <CollaborationItem collaboration={collaboration} handlerSeeCollaboration={handlerSeeCollaboration} />
                                    )
                                }))}

                            </table>
                            {(activeCollaborations.length < 1) && (<div className="notCollaborations">
                                <p><FormattedMessage id="my_collaborations_text_1" defaultMessage="No tienes colaboraciones activas" /></p>
                            </div>)}

                        </section>
                        <section >
                            <h3><FormattedMessage id="my_collaborations_title_2" defaultMessage="Colaboraciones pasadas" /></h3>
                            <table className="pastCollaborations">
                                {(showNotActiveCollaborations === true) && (notActiveCollaborations?.map((collaboration) => {
                                    return (
                                        <CollaborationItem collaboration={collaboration} handlerSeeCollaboration={handlerSeeCollaboration} />
                                    )
                                }))}

                            </table>
                            {(notActiveCollaborations.length < 1) && (<div className="notCollaborations">
                                <p><FormattedMessage id="my_collaborations_text_2" defaultMessage="No tienes colaboraciones pasadas" /></p>
                            </div>)}

                        </section>
                    </>
                )
            }

        </MyCollaborationsContainer>
    )
}